import React from 'react';
import { ReactComponent as TimeLapse } from 'assets/icons/time--lapse.svg';

export const ExpiredState: React.FC<Props | any> = (props: Props) => {
  const { isLoading } = props;
  return (
    <div className="expired-state">
      {!isLoading && (
        <>
          <div className="expired-state-icon">
            <TimeLapse />
          </div>
          <div className="expired-state-title">
            This enquiry&apos;s responses are no longer available
          </div>
          <div className="expired-state-description">
            Responses are automatically deleted 90 days after the date they were
            received.
            <br />
            You can still see the enquiry details and duplicate the enquiry.
          </div>
        </>
      )}
    </div>
  );
};

type ownProps = {
  allResponsesReceived: any;
  enquiryId: number;
  isSmallScreen: boolean;
  shareId?: string;
  responsesExpired: boolean;
  isLoading: boolean;
};

type Props = ownProps;

ExpiredState.displayName = 'ExpiredState';

export default React.memo(ExpiredState);
